import { useAtom, useAtomValue } from 'jotai';
import { priceAtom, isPriceFilterActiveAtom } from '../filterStore';

const PriceLabel = () => {
  const { valueAtom, unit } = useAtomValue(priceAtom);
  const [value] = useAtom(valueAtom);
  const filterActive = useAtomValue(isPriceFilterActiveAtom);
  const formattedMinCurrencyValue = `${unit === '$' ? '$' : ''}${value[0]}`;
  const formattedMaxCurrencyValue = `${unit === '$' ? '$' : ''}${value[1]}`;

  const displayPlus = value[1] === 70 && unit === "'" ? '+' : '';
  const displayCurrencyPlus = formattedMaxCurrencyValue === '$1,000' ? '+' : '';

  const hideLowerPriceRange = formattedMinCurrencyValue === '$0' ? '$1 - ' : `${formattedMinCurrencyValue} - `;
  const hideLowerLengthRange = value[0] === 69 ? '' : `${value[0]}' - `;

  return filterActive ? (
    <span>
      {unit === '$' ? hideLowerPriceRange : hideLowerLengthRange}
      {unit === '$' ? formattedMaxCurrencyValue : value[1]}
      {unit === "'" ? "'" : ''}
      {displayPlus}
      {displayCurrencyPlus}
    </span>
  ) : (
    <span>Price</span>
  );
};

export default PriceLabel;
